import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Pagination,
  Select,
  Box,
  Tab,
  Tabs,
} from "@mui/material";
import moment from "moment";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import {
  GetSessionStorageData,
  checkEmpty,
  checkValueNullUndefinedEmpty,
  nullUndefinedEmptyCheck,
} from "../../../../Services/Helpers/Helper";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import NoDataFound from "../../../../Shared/NoDataFound/NoDataFound";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import {
  I18_TRANSLATION_COMMON,
  API_RESPONSE,
  STORAGE_KEYS,
  NUMBER_CONSTANTS,
  COMMON_CONSTANTS,
} from "../../../../Utilities/Constants/Constants";
import "./DocumentsList.scss";
import { MenuItem } from "@mui/material";
import UploadDocumentDialog from "../UploadDocumentsDialog/UploadDocumentsDialog";
import ArticleIcon from "@mui/icons-material/Article";

const DocumentsList = () => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const { id } = useParams();
  const navigate = useNavigate();
  const [roleId, setRoleId] = useState("");
  const [myEventsList, setMyEventsList] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalCount] = useState(0);
  const [rowPerPage, setRowPerPage] = useState(10);
  const [hasProducts, setHasProducts] = useState(API_RESPONSE.FALSE);

  const [sessionsList, setSessionsList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [dateList, setDateList] = useState([]);
  const [timeList, setTimeList] = useState([]);

  const [selectedSession, setSelectedSession] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTimeList, setSelectedTimeList] = useState("");

  const [listSelectedSlot, setListSelectedSlot] = useState("");

  const [currentType, setCurrentType] = useState(NUMBER_CONSTANTS.ONE);
  const [sessionType, setSessionType] = useState(NUMBER_CONSTANTS.ZERO);
  const [tableList, setTableList] = useState<any>([]);

  const [editData, setEditData] = useState();
  const [dialogOpen, setDialogOpen] = useState<any>(API_RESPONSE.FALSE);

  const [currentIndex, setCurrentIndex] = useState(NUMBER_CONSTANTS.ZERO);

  useEffect(() => {
    getFilterData();
  }, [currentType, selectedSession, selectedUser,selectedDate,selectedTimeList]);


  /* Calls filtered list on state updates */
  useEffect(() => {
    if (sessionType > NUMBER_CONSTANTS.ZERO) getFilteredList();
  }, [sessionType, selectedSession, selectedUser,selectedDate,selectedTimeList]);

  /*  Calls filtered list on page,row per page,current index change updates */
  useEffect(() => {
    if (sessionType > NUMBER_CONSTANTS.ZERO) {
      setTableList([]);
      getFilteredList()
    }
  }, [currentIndex, page, rowPerPage])

  /**Handle row per page change */
  const onRowChange = (event: any) => {
    setPage(NUMBER_CONSTANTS.ONE);
    setRowPerPage(parseInt(event.target.value));
  };

  /* Handle page change */
  const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
    setPage(newPage);
  };

  /* Set data based on current type */
  const setData = (response: any) => {
    switch (currentType) {
      case NUMBER_CONSTANTS.ONE:
        setSessionsList(response);
        break;

      case NUMBER_CONSTANTS.TWO:
        setUsersList(response);
        break;

      case NUMBER_CONSTANTS.THREE:
        setDateList(response);
        break;

      case NUMBER_CONSTANTS.FOUR:
        setTimeList(response);
        break;
    }
  };

  const getFilterData = () => {
    // if(selectedSession !==''){
    let payload = {
      service_provider_id: selectedSession,
      teach_service_provider: `${NUMBER_CONSTANTS.ONE}`,
      user_id: selectedUser,
      start_date: nullUndefinedEmptyCheck(selectedDate)
        ? moment(selectedDate).format(COMMON_CONSTANTS.YMD_FORMAT)
        : "",
      type: currentType,
    };
    axiosInstance
      .post(API_END_POINTS.DISCOUNT_FILTER_DATA, payload)
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          setData(response.data.result.data);
        }
      });
  };

  /* Filter list API call */
  const getFilteredList = () => {
    let payload = {
      service_provider_id: selectedSession,
      teach_service_provider: `${NUMBER_CONSTANTS.ONE}`,
      childmstr_id: selectedUser,
      start_date: selectedDate
        ? moment(selectedDate).format(COMMON_CONSTANTS.YMD_FORMAT)
        : "",
      type: sessionType,
      time_slot_id: selectedTimeList,
      is_doc_uploaded: currentIndex === NUMBER_CONSTANTS.ZERO ? API_RESPONSE.TRUE : API_RESPONSE.FALSE
    };
    axiosInstance
      .post(API_END_POINTS.DISCOUNT_FILTERED_LIST, payload)
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          setTableList(response.data.result.data);
          setTotalCount(response.data.result.total_page);
          setHasProducts(checkEmpty(response.data.result.data));
        }
      });
  };

  /* Getting Role Id from session storage */
  useEffect(() => {
    moment.locale("en");
    setRoleId(GetSessionStorageData(STORAGE_KEYS.ROLE) || "");
  }, []);

  /* Action on clicking select option */
  const onSelectSession = (value: any) => {
    if (nullUndefinedEmptyCheck(value) || value !== " ") {
      setCurrentType(NUMBER_CONSTANTS.TWO);
      setTableList([]);
      setUsersList([]);
      setDateList([]);
      setTimeList([]);
      setSelectedUser("");
      setSelectedDate("");
      setSelectedTimeList("");
      setSessionType(NUMBER_CONSTANTS.ONE);
      setSelectedSession(value === " " ? "" : value);
    } else {
      onResetFilter();
    }
  };
  /* Action on clicking select option */
  const onSelectUser = (value: any) => {
    setDateList([]);
    setTimeList([]);
    setSelectedDate("");
    setSelectedTimeList("");
    setSessionType(NUMBER_CONSTANTS.TWO);
    setCurrentType(NUMBER_CONSTANTS.THREE);
    setSelectedUser(value === " " ? "" : value);
  };
  /* Action on clicking select option */
  const onSelectDate = (value: any) => {
    setTimeList([]);
    setSelectedTimeList("");
    if(value===" "){
      setSessionType(NUMBER_CONSTANTS.TWO);
      setCurrentType(NUMBER_CONSTANTS.THREE);
    }else{
      setSessionType(NUMBER_CONSTANTS.THREE);    
      setCurrentType(NUMBER_CONSTANTS.FOUR);
    }    
    setSelectedDate((prev)=>value === " " ? "" : value);
  };
  /* Action on clicking select option */
  const onSelectTime = (value: any) => {
    setSessionType(NUMBER_CONSTANTS.FOUR);
    setSelectedTimeList((prev)=>value === " " ? "" : value);
  };

  /* Open/close cover image dialog */
  const onCoverImageDialogClose = () => {
    setDialogOpen(API_RESPONSE.FALSE);
    setListSelectedSlot("");
    getFilteredList();
  };

  /* Reset Filter */
  const onResetFilter = () => {
    setTableList([]);
    setUsersList([]);
    setDateList([]);
    setTimeList([]);
    setSelectedSession("");
    setSelectedUser("");
    setSelectedDate("");
    setSelectedTimeList("");
    setTotalCount(NUMBER_CONSTANTS.ZERO);
    setHasProducts(API_RESPONSE.FALSE);
    setCurrentType(NUMBER_CONSTANTS.ONE);
    setSessionType(NUMBER_CONSTANTS.ZERO);
  };

  return (
    <div className="bookings-listview-wrapper">
      <UploadDocumentDialog
        open={dialogOpen}
        handleClose={onCoverImageDialogClose}
        data={selectedTimeList}
        listSelectedSlot={listSelectedSlot}
        editData={editData}
      />
      <div className="table-wrapper">
        <div className="select-wrapper">
          <div className="label-select">
            <label>Choose Session</label>
            <Select
              value={selectedSession !== "" ? selectedSession : " "}
              onChange={(e: any) => onSelectSession(e.target.value)}
              className="select-container"
            >
              <MenuItem value={" "}>{"Please select session"}</MenuItem>
              {sessionsList.map((session: any, i: any) => {
                return (
                  <MenuItem value={session.id}>
                    {session.session_title}
                  </MenuItem>
                );
              })}
            </Select>
          </div>
          <div className="label-select">
            <label>Choose User</label>
            <Select
              className="select-container"
              onChange={(e: any) => onSelectUser(e.target.value)}
              value={selectedUser !== "" ? selectedUser : " "}
            >
              <MenuItem value={" "}>{"Please select user"}</MenuItem>
              {usersList.map((user: any, i: any) => {
                return <MenuItem value={user?.user_id}>{user.name}</MenuItem>;
              })}
            </Select>
          </div>
          <div className="label-select">
            <label>Choose Date</label>
            <Select
              value={selectedDate !== "" ? selectedDate : " "}
              onChange={(e: any) => onSelectDate(e.target.value)}
              className="select-container"
            >
              <MenuItem value={" "}>{"Please select date"}</MenuItem>
              {dateList.map((date: any, i: any) => {
                return (
                  <MenuItem value={date.start_date}>{date.start_date}</MenuItem>
                );
              })}
            </Select>
          </div>
          <div className="label-select">
            <label>Choose Time</label>
            <Select
              className="select-container"
              onChange={(e: any) => onSelectTime(e.target.value)}
              value={selectedTimeList !== "" ? selectedTimeList : " "}
            >
              <MenuItem value={" "}>{"Please select time"}</MenuItem>
              {timeList.map((date: any, i: any) => {
                return (
                  <MenuItem value={date.time_slot_id}>
                    {date.start_time}
                  </MenuItem>
                );
              })}
            </Select>
          </div>
          <div className="label-select">
            <button
              disabled={selectedTimeList !== "" ? false : true}
              className="btn btn-primary upload-btn"
              onClick={() => setDialogOpen(API_RESPONSE.TRUE)}
            >
              Upload Documents
            </button>
          </div>
          <div className="label-select">
            <button
              className="btn btn-primary reset-btn"
              onClick={onResetFilter}
            >
              Reset
            </button>
          </div>
        </div>

        <div className="menu-wrapper">
          <Box sx={{ bgcolor: "background.paper" }}>
            <Tabs
              value={currentIndex}
              onChange={(e: any, value: number) => {
                setCurrentIndex(value);
              }}
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab className="tab-text" value={NUMBER_CONSTANTS.ZERO} label={<div className="menu-label">Documents Uploaded List</div>} />
              <Tab className="tab-text" value={NUMBER_CONSTANTS.ONE} label={<div className="menu-label">Pending Documents Upload List</div>} />
            </Tabs>
          </Box>
        </div>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t("S.NO")}</TableCell>
                <TableCell>{t("Session Title")}</TableCell>
                <TableCell>{t("User Name")}</TableCell>
                <TableCell>{t("Course Mode")}</TableCell>
                <TableCell>{t("Slot Date")}</TableCell>
                <TableCell>{t("Start Time")}</TableCell>
                <TableCell>{t("End Time")}</TableCell>
                <TableCell>{t("Actions")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableList.map((expertData: any, index: any) => {
                return (
                  <>
                    <TableRow key={index + 1}>
                      <TableCell>{(page - 1) === 0
                        ? index + 1
                        : (page - 1) *
                        rowPerPage +
                        (index + 1)}</TableCell>
                      <TableCell>{expertData.title}</TableCell>
                      <TableCell>{expertData.username}</TableCell>
                      <TableCell>{expertData.course_mode}</TableCell>
                      <TableCell>{expertData.session_slot_date}</TableCell>
                      <TableCell>{expertData.start_time}</TableCell>
                      <TableCell>{expertData.end_time}</TableCell>
                      {/* <TableCell>{expertData.username}</TableCell> */}
                      <TableCell>
                        <ArticleIcon
                          onClick={() => {
                            setDialogOpen(API_RESPONSE.TRUE);
                            setEditData(expertData.time_slot_document);
                            setListSelectedSlot(expertData.id);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
          {!hasProducts && <NoDataFound />}
        </TableContainer>
        {hasProducts && (
          <div className="tablePagination">
            <div className="row">
              <div className="col-md-7">
                <div className="pagination-wrap">
                  <Pagination
                    count={totalPage}
                    page={page}
                    onChange={handleChangePage}
                  />
                </div>
              </div>
              <div className="col-md-5">
                <div className="rows-per-page">
                  <p>{t("Rows per page")}:</p>
                  <select
                    className="rows-select"
                    value={rowPerPage}
                    onChange={onRowChange}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentsList;
